import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignTop: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="layout-align-top">
      <path
        d="M20 20V21H21V20H20ZM20 4H21V3H20V4ZM4 4V3H3V4H4ZM4 20H3V21H4V20ZM8 7H7V9H8V7ZM16 9H17V7H16V9ZM21 20V4H19V20H21ZM20 3H4V5H20V3ZM3 4V20H5V4H3ZM4 21H20V19H4V21ZM8 9H16V7H8V9Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconLayoutAlignTop;
